<template>
  <div id="forgetPasswordVue" v-cloak>
    <user-template>
      <template #title>
        <div class="resetTitle">{{form.userNameRegister}}</div>
      </template>
      <template #content>
        <div class="resetModel">
          <el-form ref="form" :model="form" label-width="80px">
            <el-form-item label="账户">
              <el-input v-model="form.user" @change="phoneNumberChange"></el-input>
            </el-form-item>
            <el-form-item label="图片验证" class="captcha" v-show="needImgVerifyCode">
              <el-input v-model="imgVerifyCode"></el-input>
              <img id="imgVerifyCode" alt="点击更换" title="点击更换" @click="changeImg">
            </el-form-item>
            <el-form-item label="验证码" class="captcha">
              <el-input v-model="form.captcha"></el-input>
              <el-button type="primary" style="float: right" @click="get_code" v-if="!getCodeDisabled">
                {{form.getCaptcha}}
              </el-button>
              <el-button type="primary" style="float: right" disabled v-else>{{clock}}</el-button>
            </el-form-item>
            <el-form-item label="新密码">
              <el-input v-model="form.password" show-password></el-input>
            </el-form-item>
            <el-form-item label="确认密码">
              <el-input v-model="form.passwordAgain" show-password></el-input>
            </el-form-item>

            <el-form-item>
              <el-button type="primary" @click="resetPassword" style="width:100%;">{{form.reset}}
              </el-button>
            </el-form-item>

          </el-form>
        </div>
      </template>
    </user-template>
  </div>

</template>

<script>
import UserTemplate from "./UserTemplate";
import API from "../../../config/api";
export default {
  components: {UserTemplate},
  data() {
    return {
      needImgVerifyCode: false,
      imgVerifyCode: '',
      form: {
        user: '',
        password: '',
        passwordAgain: '',
        captcha: '',
        userNameRegister: '重置密码',
        reset: "重置 ",
        getCaptcha: '获取验证码',
        loginUrl: `/pages/login/PcLogin`,
      },
      getCodeDisabled: false,
      clock: '',
      style: {
        refreshHeight: '100%',
      },
      logoItem: require("@/assets/login/yunKongLogo.png"),
      logoUrl: undefined
    }
  },
  methods: {
    onSubmit() {
      console.log(this.form);
      this.form.captchaStatus = false;
    },
    get_code() {
      // 获取验证码
      let self = this;
      if (self.form.user == '') {
        self.$message({type: 'warning', message: '手机号不能为空'});
      } else if (!(/^1[3456789]\d{9}$/.test(self.form.user))) {
        self.$message({type: 'warning', message: '手机号格式不正确'});
      } else if (self.needImgVerifyCode && self.imgVerifyCode == '') {
        self.$message({type: 'warning', message: '图片验证码不应该为空'});
      } else {
        self.getCodeDisabled = true;
        let header = {
          "Content-Type": "application/x-www-form-urlencoded"
        }
        let data={
          type: 2,
          phoneNumber: self.form.user,
          imgVerifyCode: self.imgVerifyCode
        }
        this.$axiosRequest({
          url: API.sendCode,
          method: 'GET',
          data: data,
          header: header,
          success: res => {
            console.log(res)
            if (res.data == 0) {
              self.$message({type: 'success', message: '验证码发送成功'});
              self.testIfNeedImgVerifyCode();// 每次验证码发送成功后，测试下一次是否需要图片验证码
            } else if (res.data == 1) {
              self.$message({type: 'warning', message: '图片验证码输入不正确，请重新输入'});
            } else if (res.data == 2) {
              self.$message({type: 'warning', message: '请先输入图片验证码后才可获取短信验证码'});
            } else {
              self.$message({type: 'warning', message: '获取验证码失败，请稍后再试'});
            }
          }
        });
        let time = 59;
        self.clock = time + "s后重新发送";
        let cleartime = setInterval(() => {
          if (time <= 0) {
            self.clock = "重新获取";
            self.getCodeDisabled = false;
            clearInterval(cleartime);
            return false;
          }
          time -= 1;
          self.clock = time + "s后重新发送";
        }, 1000);
      }
    },
    phoneNumberChange: function () {
      if (!/^1[3|4|5|7|8][0-9]{9}$/.test(this.form.user)) {
        this.needImgVerifyCode = false;
        return
      } else {
        if(!this.needImgVerifyCode)
          this.testIfNeedImgVerifyCode()
      }
    },
    resetPassword() {
      let self = this;
      if (self.form.user == '') {
        self.$message({type: 'warning', message: '手机号不能为空'});
      } else if (!(/^1[3456789]\d{9}$/.test(self.form.user))) {
        self.$message({type: 'warning', message: '手机号格式不正确'});
      } else if (self.form.password == '') {
        self.$message({type: 'warning', message: '密码不能为空'});
      } else if (self.form.passwordAgain == '') {
        self.$message({type: 'warning', message: '确认密码不能为空'});
      } else if (self.form.password != self.form.passwordAgain) {
        self.$message({type: 'warning', message: '密码和确认密码需一致'});
      } else if (self.form.captcha == '') {
        self.$message({type: 'warning', message: '验证码不能为空'});
      } else {
        let header = {
          "Content-Type": "application/x-www-form-urlencoded"
        }

        let data = {
          account: self.form.user,
          password: self.form.password,
          smsVerifyCode: self.form.captcha
        }
        this.$axiosRequest({
          url: API.resetPassword,
          method: 'POST',
          data: data,
          header: header,
          success: res => {
            console.log(res)
            if (res.data == 0) {
              self.$message({type: 'success', message: '重置成功'});
              setTimeout(function () {
                self.clearUser()// 跳转到登录页面
              }, 2000);
            } else if (res.data == 1) {
              self.$message({type: 'warning', message: '此手机号未注册'});
            } else if (res.data == -1) {
              self.$message({type: 'warning', message: '重置失败，请稍后再试'});
            } else if (res.data == 2) {
              self.$message({type: 'warning', message: '短信验证码错误'});
            } else if (res.data == 3) {
              self.$message({type: 'warning', message: '未绑定手机号'});
            }
          },
          error:res1=>{
            console.log("error:", res1);
            self.$message({type: 'warning', message: '重置失败，请稍后再试'});
          }
        });

      }
    },
    clearUser: function () {
      var self = this;
      // 调用后端接口清除session
      let header = {
        "Content-Type": "application/x-www-form-urlencoded"
      }

      let data = {}
      this.$axiosRequest({
        url: API.userLogout,
        method: 'POST',
        data: data,
        header: header,
        success: res => {
          console.log(res)
          self.$message({
            type: 'success',
            message: '注销成功!'
          });
          window.localStorage.removeItem("user")
          window.localStorage.removeItem("userid")
          window.localStorage.removeItem("token")
          window.localStorage.removeItem("companyId")
          window.localStorage.removeItem("companyRoleType")
          window.localStorage.removeItem("companyName")
          window.location.href = `#/pages/login/PcLogin`;
      }
      });
    },
    changeImg() {
      let imgVerifyCode = document.getElementById("imgVerifyCode");
      imgVerifyCode.src = this.$axios.defaults.baseURL + "/message/getImgVerifyCode?time=" + Math.random(1000) + "&phoneNumber=" + this.form.user;
      console.log("change: imgVerifyCode.src:", imgVerifyCode.src);
    },
    testIfNeedImgVerifyCode() {
      let self = this;
      if (!/^1[3|4|5|7|8][0-9]{9}$/.test(self.form.user)) {
        return
      }
      if (!self.needImgVerifyCode) {// 如果needImgVerifyCode已经为true了，就不要再调用接口判断了，直接更换验证码图片
        let header = {
          "Content-Type": "application/x-www-form-urlencoded"
        }

        let data = {}
        this.$axiosRequest({
          url: API.testIfNeedImgVerifyCodeSend,
          method: 'POST',
          data: data,
          header: header,
          success: res => {
            console.log(res)
            if(res.data == 0){
              self.needImgVerifyCode = true;
              self.changeImg();
            }
          }
        });
      } else {
        self.changeImg();
      }
    }
  },
  mounted() {
    this.logoUrl = this.logoItem;
    this.testIfNeedImgVerifyCode();
    require('@/assets/js/canvas/script.js')
  }
}
</script>

<style lang="less">

#forgetPasswordVue {
  height: 100%;
  background-size: 100% 100%;
  min-width: 1276px;
  /*登录框*/
  .resetDiv {
    padding-top: 180px;
  }

  .resetDiv .imgDiv {
    height: 100px;
    text-align: center;
    img {
      max-width: 100%;
      height: 100%;
      margin: 0 auto;
    }
  }

  .resetDiv .weChatRegister {
    text-align: center;
  }

  .resetDiv .weChatRegister img {
    height: 150px;
    width: 150px;
  }

  .resetDiv .weChatRegister img {
    padding: 10px;
    border: solid 1px #d9eedc;
  }

  .resetModel {
    background-color: #c2e2ff80;
    opacity: 0.8;
  }

  .resetModel form > div {
    width: 80%;
    margin: 12px auto;
  }

  .resetModel label {
    color: #000000 !important;
  }

  .resetTitle {
    background-color: #3a8ee6;
  }

  .resetModel form a {
    line-height: 20px;
  }

  .resetModel form button {
    width: 100%;
  }

  .captcha {
    height: 40px;
  }

  .captcha > div > div {
    width: 50%;
  }

  .captcha input {
    width: 100% !important;
    border: none;
    border-bottom: solid 1px white;
    border-radius: 0px;
    float: left;
  }

  .captcha button {
    width: 50% !important;
    padding: 12px 14px;
    float: right;
    background-color: #388cd7;
    color: white;
  }

  .el-form-item__label {
    text-align: left;
  }
  #cvs {
    position: absolute;
  }

}
</style>